import { IDenovoIconComponentProps } from "../interfaces";

export const Chain = ({
  color = "currentColor",
  width = 24,
  height = 24,
  className,
}: IDenovoIconComponentProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="-40 -40 215 106"
      stroke={color}
      transform="rotate(-0)">
      <path
        d="M 0 0 L 45 26 L 90 0 L 135 26"
        strokeLinecap="round"
        fill="none"
        strokeWidth="16"
      />
    </svg>
  );
};
